/**
 * NSW Design System footer, lower section only.
 * https://designsystem.nsw.gov.au/components/footer/index.html
 *
 * The upper section is a sitemap of link groups; this is a single-page site
 * with nothing to list there, so it is omitted rather than filled with
 * placeholder groups. Every link below was checked to return 200 when this
 * was written — the nsw.gov.au legal pages live under /about-website/, and
 * privacy and contact go to NESA's own pages since NESA runs this site and
 * collects the submissions.
 */
export const FOOTER_LINKS = [
  ["Accessibility", "https://www.nsw.gov.au/nsw-government/about-website/accessibility-statement"],
  ["Copyright", "https://www.nsw.gov.au/nsw-government/about-website/copyright"],
  ["Disclaimer", "https://www.nsw.gov.au/nsw-government/about-website/disclaimer"],
  ["Privacy", "https://www.nsw.gov.au/education-and-training/nesa/about/privacy"],
  ["Contact NESA", "https://www.nsw.gov.au/education-and-training/nesa/contact-us"],
];

const NswFooter = () => (
  <footer className="nsw-footer">
    <div className="nsw-footer__lower">
      <div className="nsw-container">
        <p className="nsw-footer__acknowledgement">
          We pay respect to the Traditional Custodians and First Peoples of NSW,
          and acknowledge their continued connection to their country and
          culture.
        </p>
        <hr />
        <ul>
          {FOOTER_LINKS.map(([label, href]) => (
            <li key={href}>
              <a href={href}>{label}</a>
            </li>
          ))}
        </ul>
        <div className="nsw-footer__info">
          <p className="nsw-footer__copyright">
            Copyright © {new Date().getFullYear()} NSW Education Standards Authority
          </p>
        </div>
      </div>
    </div>
  </footer>
);

export default NswFooter;
